import { Injectable } from '@angular/core';
import { ModuleType } from '../types/module-type';
import { AccessRightType } from '../types/access-right-type';
import { ApplicationSettingsType } from '../types/application-settings-type';
import { fiHasAccessToApplicationType } from '../utils/has-access-to-application-type';
import { FiCustomerDataService } from './fi-customer-data.service';
import { FiUserDataService } from '@fi-shared/fi-shared-services/fi-user-data.service';

@Injectable()
export class AccessToApplicationTypeService {
    constructor(
        private customerDataService: FiCustomerDataService,
        private userDataService: FiUserDataService,
    ) {}

    HasAccessToApplicationType(applicationSettingType: ApplicationSettingsType, accessLevel: AccessRightType, user?) {
        let that = this;

        var moduleAccessRights = (function () {
            if (user && user.ModuleAccessRights) return user.ModuleAccessRights;
            if (that.userDataService.userData) return that.userDataService.userData.ModuleAccessRights;
            return null;
        })();

        if (moduleAccessRights) {
            return fiHasAccessToApplicationType(applicationSettingType, accessLevel, moduleAccessRights);
        }

        return false;
    }

    hasCustomerAccessToModule(moduleType: ModuleType) {
        const applicationSettingTypes = this.getApplicationSettingTypesByModuleType(moduleType);
        return !!applicationSettingTypes.find((applicationSettingType: ApplicationSettingsType) => {
            return !!this.customerDataService.customerData.ApplicationSettingAccessTypes.find((activatedModule) => {
                return activatedModule.ApplicationSettingType === applicationSettingType;
            });
        });
    }

    private getApplicationSettingTypesByModuleType(moduleType: ModuleType): ApplicationSettingsType[] {
        if (moduleType == ModuleType.CheckList)
            return [ApplicationSettingsType.ChecklistCentral, ApplicationSettingsType.ChecklistLocal];

        if (moduleType === ModuleType.Personalkollen) return [ApplicationSettingsType.Personalkollen];

        if (moduleType === ModuleType.Planday) return [ApplicationSettingsType.Planday];

        if (moduleType == ModuleType.ChecklistV2)
            return [
                ApplicationSettingsType.ChecklistV2Global,
                ApplicationSettingsType.ChecklistV2Central,
                ApplicationSettingsType.ChecklistV2Local,
            ];

        if (moduleType == ModuleType.ChecklistV2Audit)
            return [
                ApplicationSettingsType.ChecklistV2AuditGlobal,
                ApplicationSettingsType.ChecklistV2AuditCentral,
                ApplicationSettingsType.ChecklistV2AuditLocal,
            ];

        if (moduleType == ModuleType.TaskV2)
            return [
                ApplicationSettingsType.TaskV2Global,
                ApplicationSettingsType.TaskV2Central,
                ApplicationSettingsType.TaskV2Local,
            ];

        if (moduleType == ModuleType.Onboarding)
            return [
                ApplicationSettingsType.OnboardingGlobal,
                ApplicationSettingsType.OnboardingCentral,
                ApplicationSettingsType.OnboardingLocal,
            ];

        return []; //todo
    }
}
